// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__V5oUd","inner":"Footer_inner__2HtMB"};